import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import { vh } from "@/utils/common";
import { axios } from "@/utils/axios";
import { api } from "@/assets/http/api";
Vue.config.productionTip = false;
Vue.prototype.$vh = vh;
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
